import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.less'],
})
export class SpinnerComponent implements OnInit {
  @Input() loaderSize = 'small';

  constructor() {}

  ngOnInit(): void {}
}
